import React from 'react'
import classnames from 'classnames'
import styles from './ErrorPage.module.scss'
import Analytics from 'analytics'
import PrivateWealthEmailLink from '../Shared/PrivateWealthEmailLink/PrivateWealthEmailLink'

const handleHelpClick = () => {
  Analytics.track('User clicks Need Help on pagenotfound')
}

const cta = (message, href) => (
  <a
    href={href}
    className={classnames('button button--primary', styles.redirectLink)}
    data-test-id="failureMessage"
    onClick={handleHelpClick}>
    {message}
  </a>
)


export const defaultCta = () => (
  <PrivateWealthEmailLink message="Need Help?" className={classnames('button button--primary', styles.redirectLink)} />
)

export const helpLink = (message = 'let your team know') => (
  <PrivateWealthEmailLink message={message} className={classnames('button button--primary', styles.redirectLink)} />
)

export default cta



// WEBPACK FOOTER //
// ./src/components/ErrorPage/cta.js